import moment from 'moment-timezone'
import { filter, head, sortBy } from 'lodash-es'
import Calendar from '@/models/company/Calendar'

export default class EmployeeAllowanceCalendar {
  employeeCalendars = []

  constructor(employee, calendars) {
    this.employee = employee
    this.calendars = calendars

    this.fetchEmployeeCalendars()
  }

  fetchEmployeeCalendars() {
    if (
      !this.employee ||
      !this.employee.company.allow_calendar_align_to_start_date ||
      this.employee.is_using_default_allowance_years
    ) {
      this.employeeCalendars = this.calendars.map(calendar => {
        return new Calendar({
          ...calendar,
          start_date: moment.utc(calendar.start_date),
          end_date: moment.utc(calendar.end_date),
        })
      })

      return
    }

    this.employeeCalendars = Object.values(this.employee.allowance_years).map(
      calendar =>
        new Calendar({
          ...calendar,
          start_date: moment.utc(calendar.start_date),
          end_date: moment.utc(calendar.end_date),
        })
    )
  }

  getEmployeeCalendars() {
    return this.employeeCalendars
  }

  getCurrentYearCalendar() {
    const today = moment().utc(true)

    return this.employeeCalendars.find(calendar => {
      return today.isBetween(calendar.start_date, calendar.end_date)
    })
  }

  getCurrentAndNextCalendars() {
    const today = moment().utc(true)

    return filter(this.employeeCalendars, calendar => {
      return (
        today.isBetween(calendar.start_date, calendar.end_date) ||
        today.isSameOrBefore(calendar.start_date, 'days')
      )
    })
  }

  getNearestCalendar() {
    const today = moment().utc(true)

    return head(
      sortBy(this.employeeCalendars, calendar => {
        return Math.abs(
          Math.min(
            today.diff(calendar.start_date, 'days'),
            today.diff(calendar.end_date, 'days')
          )
        )
      })
    )
  }

  getCalendarForPeriod(period) {
    if (!period) return null

    const [start, end] = period.split(',')

    return this.employeeCalendars.find(
      calendar =>
        moment
          .utc(start, true)
          .isBetween(calendar.start_date, calendar.end_date) &&
        moment.utc(end, true).isBetween(calendar.start_date, calendar.end_date)
    )
  }
}
